import React, { PropTypes } from "react";
import { Button } from "react-bootstrap";
import classNames from "classnames";

// Prefers Odd numbers for better centering
export const MAX_PAGE_COUNT = 17;

export const getPageArray = (
  pages,
  currentPage,
  MAX_COUNT = MAX_PAGE_COUNT
) => {
  // Short Circuit if pagination doesn't require special function
  if (pages <= MAX_COUNT) {
    return Array(pages)
      .fill()
      .map((_, i) => i);
  }

  // GOBO check - Prevent negative or overshot offsets
  currentPage = Math.min(pages - 1, Math.max(0, currentPage));

  const lastPage = pages - 1;
  const delta = Math.floor((MAX_COUNT - 2) / 2);

  // Calculate starting page range : Min is 0, Max is Pages - MAX_COUNT
  const rangeStart = Math.min(
    lastPage - (MAX_COUNT - 2),
    Math.max(1, currentPage - delta)
  );

  // Create and Map Page Array
  return Array(MAX_COUNT)
    .fill()
    .map((_, i) => {
      // First page is always present
      if (i === 0) return 0;

      // Last page is always present
      if (i === MAX_COUNT - 1) return pages - 1;

      const pageNum = i - 1 + rangeStart;

      // Second and second-to-last pages are replaced with ellipsis if not at the limit
      if (
        (i === 1 && pageNum !== 1) ||
        (i === MAX_COUNT - 2 && pageNum !== pages - 2)
      ) {
        return -1;
      }

      // Everything else is based on currentPage's delta (using)
      return pageNum;
    });
};

const TablePages = (props, context) => {
  const { totalRows, rowsPerPage, offset } = props;
  const pages = Math.ceil(totalRows / rowsPerPage);
  const currentPage = Math.ceil(offset / rowsPerPage);
  const buttonNumbers = getPageArray(pages, currentPage);
  const handleClick = (newOffset) => {
    props.setOffset(newOffset);
    context.scrollTop();
  };

  let buttons = buttonNumbers.map((number, index) => {
    const pageClass = classNames({
      btn: true,
      "btn-page": true,
      "btn-filled": true,
      "btn-default": number * rowsPerPage != props.offset,
      "btn-primary": number * rowsPerPage == props.offset,
    });

    const isDisabled = number === -1;
    const label = number === -1 ? "..." : number + 1;
    const key = number === -1 ? -index : number;

    return (
      <Button
        onClick={() => {
          if (number > -1 && number * rowsPerPage != props.offset) {
            handleClick(number * rowsPerPage);
          }
        }}
        disabled={isDisabled}
        key={key}
        type="button"
        className={pageClass}
      >
        {label}
      </Button>
    );
  });

  if (buttonNumbers.length > 1) {
    const hasPrev = props.offset > 0;
    const hasNext = !(
      buttonNumbers.length == 0 || props.offset == (pages - 1) * rowsPerPage
    );
    return (
      <div className="table-pages">
        <Button
          onClick={handleClick.bind(null, offset - rowsPerPage)}
          key={"prev"}
          type="button"
          className="btn btn-filled btn-default btn-navigation"
          disabled={!hasPrev}
        >
          <span className="icon-chevron-small-left" />
        </Button>
        <div className="btn-pages">{buttons}</div>
        <Button
          onClick={handleClick.bind(null, offset + rowsPerPage)}
          key={"next"}
          type="button"
          className="btn btn-filled btn-default btn-navigation"
          disabled={!hasNext}
        >
          <span className="icon-chevron-small-right" />
        </Button>
      </div>
    );
  }
  return <div />;
};

TablePages.propTypes = {
  offset: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number,
  setOffset: PropTypes.func.isRequired,
  totalRows: PropTypes.number,
  pagination: PropTypes.object // used by data table v2
};

TablePages.contextTypes = {
  scrollTop: PropTypes.func,
};

export default TablePages;



// WEBPACK FOOTER //
// ./src/components/common/DataTable/TablePages.js